import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OrderAdd from "./OrderAdd";
import OrderEdit from "./OrderEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import SelectFCenter from "./SelectFCenter";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ko } from "date-fns/locale";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Purchase() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [fcid, setFcid] = useState("");
  const [date, setDate] = useState(null);

  const open = Boolean(anchorEl);

  // 폼 데이타
  const [data, setData] = useState({
    sname: "",
    sphone: "",
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록", width: 140, align: "center" },
    {
      field: "name",
      headerName: "이름",
      width: 120,
      renderCell: (params) => {
        return (
          <Typography
            sx={{ p: 1 }}
            onMouseEnter={(event) => onPopoverOver(event, params.row.phone)}
            onMouseOut={onPopoverOut}
          >
            {params.row.name}
          </Typography>
        );
      },
    },
    {
      field: "gubun",
      headerName: "구분",
      width: 110,
      renderCell: (params) => {
        return params.row.gubun;
      },
    },
    {
      field: "item",
      headerName: "상품명",
      width: 190,
      renderCell: (params) => {
        return params.row.itemName;
      },
    },
    {
      field: "amount",
      headerName: "구매가",
      width: 90,
      align: "right",
      renderCell: (params) => {
        return params.row.amountf;
      },
    },
    { field: "pt_count", headerName: "수량", align: "center" },
    { field: "method", headerName: "결제구분", align: "center" },
    { field: "term", headerName: "유효기간", width: 200, align: "center" },
    { field: "cname", headerName: "센터명", width: 140, align: "cname" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    load_data();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("load_data");
    let result = await axios.post(configState.api + "/gympass_admin/purchase", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sname: data.sname,
      sphone: data.sphone,
      fcid: fcid,
      sdate: date,
    });
    log(result.data);
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded && tcid !== "") {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = async () => {
    load_data();
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            구매관리
          </h3>

          <Box
            display="flex"
            sx={{ maxWidth: 1300, alignItems: "center", mb: 1 }}
          >
            <Box>
              <CenterSelect
                login={login}
                tcidParent={tcid}
                setTcidParent={setTcid}
              />
            </Box>

            <Box flexGrow="1" sx={{ textAlign: "right" }}>
              {(login.level === "500" || login.level === "100") && (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={onOpenAdd}
                >
                  구매추가
                </Button>
              )}
            </Box>
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>
            {/* 이름 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="sname"
                label="이름"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 180, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box>
            <Box>
              {/* <TextField
                sx={{ width: 120, ml: 1 }}
                name="sdate"
                label="유효기간"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField> */}

              <div style={{ marginLeft: 10 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                  <DatePicker
                    name="sdate"
                    label="유효기간"
                    value={date}
                    onChange={(newValue) => {
                      setDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Box>
            <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              setShowEdit(true);
            }}
          />

          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="md"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>구매추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <OrderAdd
              tcidParent={tcid}
              login={login}
              onCloseAddPop={onCloseAddPop}
            ></OrderAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="md"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>구매수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <OrderEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></OrderEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Purchase;
